import { render, staticRenderFns } from "./caririskRaporuOrtvadeRenderer.vue?vue&type=template&id=1d07954c&"
import script from "./caririskRaporuOrtvadeRenderer.vue?vue&type=script&lang=js&"
export * from "./caririskRaporuOrtvadeRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports